import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";
import { tablePrefixCls } from "@/base/components/index";

const useStyles = createStyles(({ token, css }: any) => ({
  section: css``,
  body: css``,
  search: css`
    max-width: 720px;
  `,
  actions: css`
    flex: 1;
  `,
  spin: css`
    min-height: 480px;
  `,
  table: css`
    .${tablePrefixCls}-header {
      top: var(--page-header-height) !important;
    }
    .${tablePrefixCls}-pagination {
      position: sticky;
      bottom: 0;
      background: ${token.ColorFigmaNeutralGrayscaleGray10};
      padding: 16px 0;
      margin: 0 !important;
    }
  `,
  header: css``,
}));

export const usePageTableStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
